/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FC, useEffect, useState, useRef, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { getAllMOvInventario } from '../../../service/dashboard/Dashboard';
import RadialBarChart from '../../../../_mexablock/helpers/components/RadialBarChaart';
import { LoadingGrid } from '../../../../_mexablock/helpers';

type Props = {
  filterDate: any;
};

type TotalesItem = {
  total_stock: number;
  status: {
    id: number;
    name: string;
    order: number;
  };
};

type DataSends = {
  unavailableTotal: number;
  stockStatus: TotalesItem[];
};

const MovInventory: FC<Props> = ({ filterDate }) => {
  const history = useHistory();
  const [dataSends, setDataSends] = useState<DataSends | null>(null);
  const prevFiltersRef = useRef<string>();
  
  // Usar useMemo para estabilizar el objeto de filtros
  const filters = useMemo(() => ({
    init_date: filterDate.init_date,
    end_date: filterDate.end_date,
  }), [filterDate.init_date, filterDate.end_date]);

  const fetchPost = async () => {

    try {
      const sends = await getAllMOvInventario(filters);
      if (sends) {
        setDataSends(sends);
      }
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  const disponible = dataSends?.stockStatus?.find(
    (item: any) => item.status.id === 9
  );
  const asignadas = dataSends?.stockStatus?.find(
    (item: any) => item.status.id === 11
  );
  const activadas = dataSends?.stockStatus?.find(
    (item: any) => item.status.id === 7
  );
  const portada = dataSends?.stockStatus?.find(
    (item: any) => item.status.id === 8
  );
  const suspendido = dataSends?.stockStatus?.find(
    (item: any) => item.status.id === 16
  );
  const cancelada = dataSends?.stockStatus?.find(
    (item: any) => item.status.id === 17
  );

  const otros = (suspendido?.total_stock || 0) + (cancelada?.total_stock || 0);
  // (disponible?.total_stock || 0);
  const total =
    (asignadas?.total_stock || 0) +
    (activadas?.total_stock || 0) +
    (portada?.total_stock || 0) +
    (suspendido?.total_stock || 0) +
    (disponible?.total_stock || 0) +
    (cancelada?.total_stock || 0);

  useEffect(() => {
    const filtersString = JSON.stringify(filters);
    
    // Evitar llamadas duplicadas
    if (prevFiltersRef.current === filtersString) return;
    prevFiltersRef.current = filtersString;
    
    if (filterDate) {
      fetchPost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <div className="card card-flush w-50 h-550px">
      <div className="card-header pt-5">
        <div className="card-title d-flex flex-column">
          <div className="d-flex align-items-center">
            <span className="fs-2 fw-bolder text-gray-900 me-2 lh-1 ls-n2">
              Movimientos de inventario
            </span>
          </div>
          <span className="text-gray-500 pt-1 fw-semibold fs-6">
            Detalles de Inventario
          </span>
        </div>
      </div>

      <div className="card-body d-flex flex-center">
        {dataSends ? (
          <RadialBarChart
            act={activadas?.total_stock || 0}
            por={portada?.total_stock || 0}
            asi={asignadas?.total_stock || 0}
            otr={otros || 0}
          />
        ) : (
          <LoadingGrid text="Cargando gráfico..." />
        )}
      </div>
      <div className="d-flex flex-column justify-content-center align-items-center text-center p-5">
        <div className="text-gray-700 mb-4 fs-5">
          Total:{' '}
          <span className="fw-bolder">{dataSends?.unavailableTotal}</span> de{' '}
          <span className="fw-bolder">{total}</span> unidades
        </div>

        <button
          className="btn btn-sm btn-light-primary fs-6"
          onClick={() => {
            history.push('/inventario/producto');
          }}
        >
          Ver detalle
          <i className="bi bi-arrow-right ms-2" />
        </button>
      </div>
    </div>
  );
};

export { MovInventory };
